import httpClient from "../../lib/httpClient";
// We do not need to use "await" in the call to saveUserMonitorData,
// because we do not need to wait for the response, it is just for statistics purposes.
export const saveUserMonitorData = async (page: string, detail: string) => {
  const storedUser = localStorage.getItem("user");

  if (storedUser) {
    const user = JSON.parse(storedUser);
    try {
      await httpClient().post("userMonitor", { email: user?.email, page, detail });
    } catch (error) {
      console.log("Error saving user monitor data");
    }
  }
};

export const getUserData = () => {
  const storageUser = localStorage.getItem("user");
  if (!storageUser) {
    throw new Error("User data not found in local storage");
  }
  const user = JSON.parse(storageUser);
  return user;
};
